
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5dae05ca!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DataTableInfoBox.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataTableInfoBox.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5dae05ca!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataTableInfoBox.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DataTableInfoBox.vue
// module id = 187
// module chunks = 2